// notification_templates.* — menu_item_id 99 (IDs from backend permissions API)

/** notification_templates.index */
export const NOTIFICATION_TEMPLATES_INDEX = 1285;
/** notification_templates.update */
export const NOTIFICATION_TEMPLATES_UPDATE = 1286;
/** notification_templates.toggle */
export const NOTIFICATION_TEMPLATES_TOGGLE = 1287;
/** notification_templates.test */
export const NOTIFICATION_TEMPLATES_TEST = 1288;
/** notification_templates.reset */
export const NOTIFICATION_TEMPLATES_RESET = 1289;
